import React from 'react';
import { motion } from 'framer-motion';
// Import specific icons from react-icons
import { FaSalesforce, FaCloudUploadAlt, FaChalkboardTeacher, FaDatabase, FaBriefcase } from 'react-icons/fa';
import { SiSap } from 'react-icons/si';

// Remove old placeholder icon components

const serviceItems = [
  {
    Icon: FaSalesforce, // Use imported icon
    title: 'Salesforce Solutions',
    description: 'Custom Salesforce implementation, integration, and optimization for your CRM needs.',
  },
  {
    Icon: SiSap, // Use imported icon
    title: 'SAP Implementation',
    description: 'End-to-end SAP solutions for streamlining business processes and operations.',
  },
  {
    Icon: FaBriefcase, // Changed to FaBriefcase as a fallback
    title: 'Dynamics 365',
    description: 'Microsoft Dynamics 365 services to enhance customer engagement and operations.',
  },
  {
    Icon: FaDatabase, // Use imported icon (FaDatabase as a placeholder for migration)
    title: 'Data Migration',
    description: 'Secure and efficient data migration services for your enterprise applications.',
  },
  {
    Icon: FaCloudUploadAlt, // Use imported icon
    title: 'Cloud Services',
    description: 'Comprehensive cloud migration and management solutions for your business.',
  },
  {
    Icon: FaChalkboardTeacher, // Use imported icon
    title: 'Training & Support',
    description: 'Expert training and ongoing support for all enterprise solutions we provide.',
  },
];

function Services() {

    // Updated: More distinct section variant (slide in from right)
    const sectionSlideInRight = {
        hidden: { opacity: 0, x: 100 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.6, ease: "easeOut", staggerChildren: 0.1, delayChildren: 0.2 }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { type: 'spring', stiffness: 100 }
        }
    };

    // Variant for the card lift effect
    const cardHoverVariant = {
      hover: {
        y: -8, // Lift card slightly
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)" // Enhance shadow (Tailwind shadow-lg)
      }
    };

  return (
    <section id="services" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
            className="text-center mb-16"
            initial={{ opacity: 0, y: -20 }} // Keep simple fade-up for header
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
            >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Core Services</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
            We provide comprehensive enterprise solutions to drive your business forward efficiently.
          </p>
        </motion.div>

        {/* Service Grid */}
        <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
            variants={sectionSlideInRight} // Apply slide-in variant to the grid container
            initial="hidden"
            whileInView="visible" // Use whileInView for scroll triggering
            viewport={{ once: true, amount: 0.1 }} // Trigger when 10% is visible
        >
          {serviceItems.map((item, index) => (
            <motion.div
                key={index}
                variants={itemVariants} // Staggered items within the grid
                className="h-full"
            >
              {/* Added motion div wrapper for card hover effect */}
              <motion.div 
                className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 transition-all duration-300 flex flex-col items-center text-center h-full"
                variants={cardHoverVariant} // Use card hover variants
                whileHover="hover" // Trigger hover animation
              >
                <motion.div 
                  className="p-4 rounded-full bg-gradient-to-br from-blue-100 to-cyan-100 text-primary mb-5 inline-flex text-3xl" // Increased icon size
                  whileHover={{ scale: 1.15, rotate: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <item.Icon />
                </motion.div>
                <h3 className="text-xl font-semibold mb-3 text-gray-800">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Services; 